// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/aeccb695/" + chunkId + "." + __webpack_require__.h() + ".vaeccb695.js";
};